import React from 'react';
import { FormattedMessage  } from 'react-intl';
import {
  Checkbox,
  DatePicker,
  Dropdown,
  Input,
  Menu,
  Spin,
  TreeSelect,
  Pagination,
  Col, Row
} from 'antd';
import moment from 'moment';

//  用户预订查询
const MenuItem = Menu.Item;
const CheckboxGroup = Checkbox.Group;

const showData = (e, item, intl) => {
  switch (e) {
    case 'main_meeting_time_length':
      return Math.floor((item.meetingLength / 60) * 100) / 100;
    case 'main_meeting_attends_list':
      // return item.memberNames+';'+item.fuNames;
      return item.memberNames && !item.fuNames
        ? item.holderName + ';' + item.memberNames
        : !item.memberNames && item.fuNames
          ? item.holderName + ';' + item.fuNames
          : item.memberNames && item.fuNames
            ? item.holderName + ';' + item.memberNames + ';' + item.fuNames
            : item.holderName;
    case 'main_room_capacity':
      //return item.seat == 1 ? '1-3人' : item.seat == 2 ? '4-9人' : '超过10人';
      return item.minNumber + '-' + item.maxNumber + '人';
    case 'main_meeting_sign_rate':
      return item.signRate + '%';
    case 'report_roomDetail_unSignNames':
      return item.noSignMembers;
    case 'main_meeting_disuse':
      return intl.formatMessage({id: item.isNoUse == 0 ? 'yes' : "no"});
    case 'report_abnormal_extend':
      return intl.formatMessage({id: item.isExtend == 0 ? 'yes' : "no"});
    case 'report_abnormal_early_end':
      return intl.formatMessage({id: item.isEndBefore == 0 ? 'yes' : "no"});
    case 'resource_name_meeting_type':
      return item.meetingSource == 0
        ? '会议系统'
        : item.meetingSource == 1
          ? '平台预订'
          : item.meetingSource == 2
            ? '手机预订'
            : item.meetingSource == 3
              ? 'Exchange|Outlook'
              : item.meetingSource == 4
                ? 'Domino|Notes'
                : 'GoogleCalendar';
    case 're_cycle_meeting':
      return intl.formatMessage({id: item.isRecurring == 0 ? 'yes' : "no"});
  }
};

export default ({
  intl,
  dispatch,
  loading,
  userReport,
  roomReport,
  account
}) => {
  const {
    startTime,
    endTime,
    bookName,
    searchData,
    pageNo,
    pageSize,
  } = userReport;

  const handleVisibleChange = flag => {
    dispatch({
      type: 'userReport/setState',
      payload: { dropVis: flag }
    });
  };

  const tableList = (data, pageNo, userReport, intl) => {
    return data.map((item, index) => {
      return (
        <li key={index}>
          <div
            className={
              userReport.moreMenu.length <= 2
                ? 'tip-case reportTable'
                : userReport.moreMenu.length <= 6 &&
                userReport.moreMenu.length > 2
                ? 'tip-case reportTable middle-width-scroll'
                : 'tip-case reportTable max-width-scroll'
            }
          >
            <div className="meeting-index">{item.creatorDeptName}</div>
            <div className="meeting-num">{item.creatorName}</div>
            <div className="meeting-date">
              {moment(item.startDate).format('YYYY-MM-DD')}
            </div>
            <div className="meeting-time">
              {moment(item.meetingStartTime).format('HH:mm') +
              '-' +
              moment(item.meetingEndTime).format('HH:mm')}
            </div>
            <div className="sign-length">{intl.locale === 'en_US'?item.roomNamesEn:item.roomNames}</div>
            <div className="sign-num">{item.meetingName}</div>
            <div className="meeting-occupy">{item.holderName}</div>
            <div className="meeting-detail">{item.attenderNum}</div>
            <div className="meeting-detail">{item.signNum}</div>
            {/*根据获取到的moreMenu在表格进行添加*/}
            {userReport.moreMenu &&
            userReport.moreMenu.map((e, index) => {
              return (
                <div className="meetingMore" key={index}>
                  {/*对传来的e进行判断，分别根据不同的字段进行数据的展示*/}
                  {showData(e, item, intl)}
                </div>
              );
            })}
          </div>
        </li>
      );
    });
  }
  /**
   * 更多选项选择方法
   */
  const checkOnChange = checkedValues => {
    dispatch({
      type: 'userReport/setState',
      payload: {
        moreMenu: checkedValues,
        indeterminate:
          !!checkedValues.length &&
          checkedValues.length < userReport.userAllMoreMenu.length,
        checkAll: checkedValues.length === userReport.userAllMoreMenu.length
      }
    });
  };
  /**
   * 更多选项全选方法
   */
  const onCheckAllChange = e => {
    dispatch({
      type: 'userReport/setState',
      payload: {
        indeterminate: false,
        checkAll: e.target.checked,
        moreMenu: e.target.checked
          ? userReport.userAllMoreMenu.map(e => e)
          : []
      }
    });
  };
  const menu = (
    <Menu className="roomReport-menu">
      <MenuItem>
        <div>
          <div style={{ borderBottom: '1px solid #E9E9E9' }}>
            <Checkbox
              indeterminate={userReport.indeterminate}
              onChange={onCheckAllChange}
              checked={userReport.checkAll}
            >
              {intl.formatMessage({ id: 'all_select' })}
            </Checkbox>
          </div>
          <br />
          <CheckboxGroup
            value={userReport.moreMenu}
            onChange={checkOnChange}
          >
            <Col>
              {
                userReport.userAllMoreMenu.map(menu => {
                  return <Row key={menu} span={8}>
                    <Checkbox
                      value={menu}
                    >
                      <FormattedMessage id={menu}/>
                    </Checkbox>
                  </Row>;
                })
              }
            </Col>
          </CheckboxGroup>
        </div>
      </MenuItem>
    </Menu>
  );

  let convertDeptTree = childDepts => {
    for (let i = 0; i < childDepts.length; i++) {
      let temp = childDepts[i];
      temp.label = temp.name;
      temp.value = temp.id + ',' + temp.name;
      temp.key = temp.id + ',' + temp.name;
      temp.children = temp.depts;
      if (temp.children.length > 0) {
        convertDeptTree(temp.children);
      }
    }
  };

  let treeData = account.allDeptList || [];
  convertDeptTree(treeData);
  return (
    <div className="message-body userreport report-room report-container">
      {/*<div className="messages-first">
        <div className="nav">
          <a>{intl.formatMessage({ id: 'report_user_title' })}</a>
        </div>
      </div>*/}
      <div className="user-report-container">
        <Spin spinning={loading} size="large">
          <div className="messages-list room-report-title">
            <div className="messages-title roomReport-head userReport">
              <div className="report-div report-area">
                <label className="report-search-label">
                  {intl.formatMessage({ id: 'user_department' })}
                </label>
                <div className="search-input">
                <span className="menu-border">
                  <i className="iconfont icon-sousuo" />
                  <TreeSelect
                    // value={userReport.deptName}
                    dropdownStyle={{
                      maxHeight: 400,
                      overflow: 'auto',
                      minWidth: 200
                    }}
                    allowClear
                    treeData={treeData}
                    placeholder={intl.formatMessage({ id: 'pls_check_depart' })}
                    treeDefaultExpandAll
                    notFoundContent={intl.formatMessage({
                      id: 'user_dept_notFound'
                    })}
                    onChange={e => {
                      if (e) {
                        dispatch({
                          type: 'userReport/setState',
                          payload: { deptName: e, deptId: e.split(',')[0] }
                        });
                      } else {
                        dispatch({
                          type: 'userReport/setState',
                          payload: { deptName: '', deptId: '' }
                        });
                      }
                    }}
                  />
                </span>
                </div>
              </div>
              <div className="report-div report-book-user">
                <label className="report-search-label">
                  {intl.formatMessage({ id: 'report_user' })}
                </label>
                <Input
                  placeholder={intl.formatMessage({
                    id: 'report_user_pls_name_f'
                  })}
                  value={bookName}
                  onChange={e => {
                    dispatch({
                      type: 'userReport/setState',
                      payload: { bookName: e.target.value }
                    });
                  }}
                />
              </div>
              <div className="report-div report-date">
                <label className="report-search-label" >
                  {intl.formatMessage({ id: 'report_date' })}
                </label>
                <div className="date-range-width">
                  <DatePicker
                    allowClear={false}
                    value={startTime}
                    disabledDate={current => {
                      return (
                        current &&
                        current.startOf('day').valueOf() >=
                        endTime.startOf('day').valueOf()
                      );
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'userReport/setState',
                        payload: { startTime: e }
                      });
                    }}
                  />
                  ~
                  <DatePicker
                    allowClear={false}
                    value={endTime}
                    disabledDate={current => {
                      return (
                        startTime.valueOf() > current.valueOf() ||
                        current.startOf('day').valueOf() >=
                        moment()
                          .startOf('day')
                          .valueOf()
                      );
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'userReport/setState',
                        payload: { endTime: e }
                      });
                    }}
                  />
                </div>
              </div>
              <div className="report-div report-btn-group">
                <button
                  className="button_primary"
                  onClick={() => {
                    dispatch({ type: 'userReport/search' });
                  }}
                >
                  <FormattedMessage id="report_search" />
                </button>
                <button
                  onClick={() => {
                    dispatch({ type: 'userReport/downloadUser' });
                  }}
                >
                  <FormattedMessage id="report_download" />
                </button>
              </div>
            </div>
          </div>

          {/*表格*/}

          <div style={{ position: 'relative', height: '20px' }}>
            <Dropdown
              overlay={menu}
              visible={userReport.dropVis}
              onVisibleChange={handleVisibleChange}
            >
              <a
                className="ant-dropdown-link"
                style={{ color: '#333', position: 'absolute', right: '30px' }}
              >
                {intl.formatMessage({ id: 'report_display' })}
              </a>
            </Dropdown>
          </div>

          <div
            className="messages-list room-report-table"
            style={{ minHeight: '620px' }}
          >
            <div
              className={
                userReport.moreMenu.length <= 2
                  ? 'tip-case reportTable'
                  : userReport.moreMenu.length <= 6 &&
                  userReport.moreMenu.length > 2
                  ? 'tip-case reportTable middle-width-scroll'
                  : 'tip-case reportTable max-width-scroll'
              }
            >
              <div className="meeting-index">
                {intl.formatMessage({ id: 'report_user_userDept' })}
              </div>
              {false && <div className="meeting-area" />}
              <div className="meeting-num">
                {intl.formatMessage({ id: 'report_user' })}
              </div>
              <div className="meeting-date">
                {intl.formatMessage({ id: 'report_meeting_date' })}
              </div>
              <div className="meeting-time">
                {intl.formatMessage({ id: 'report_meeting_time' })}
              </div>
              <div className="sign-length">
                {intl.formatMessage({ id: 'report_room_name' })}
              </div>
              <div className=" sign-num">
                {intl.formatMessage({ id: 'report_meeting_theme' })}
              </div>
              <div className="meeting-occupy">
                {intl.formatMessage({ id: 'main_meeting_holder' })}
              </div>
              <div className="meeting-detail">
                {intl.formatMessage({ id: 'main_meeting_attends' })}
              </div>
              <div className="meeting-detail">
                {intl.formatMessage({ id: 'main_meeting_sign' })}
              </div>
              {/*根据获取到的moreMenu在表头进行添加*/}
              {userReport.moreMenu &&
              userReport.moreMenu.map((e, index) => {
                return (
                  <div className={'meetingMore'} key={index}>
                    <FormattedMessage id={e}/>
                  </div>
                );
              })}
            </div>
            <ul
              className={
                searchData.list == undefined
                  ? ''
                  : searchData.list.length == 0
                  ? 'emptyData'
                  : 'messages'
              }
            >
              {searchData.list == undefined
                ? ''
                : searchData.list.length == 0
                  ? intl.formatMessage({ id: 'smart_device_drop_down_no_data' })
                  : ''}
              {searchData.list && tableList(searchData.list, pageNo, userReport, intl)}
            </ul>
            <div
              className="page-cont"
            >
              {searchData.list &&
              searchData.list.length > 0 && (
                <Pagination
                  total={searchData.total || 0}
                  showQuickJumper
                  showSizeChanger
                  pageSize={pageSize || 10}
                  current={pageNo || 1}
                  onShowSizeChange={(page, pageSize) => {
                    dispatch({
                      type: 'userReport/changePage',
                      payload: { pageNo: page, pageSize: pageSize}
                    });
                  }}
                  onChange={(page, pageSize) => {
                    dispatch({
                      type: 'userReport/changePage',
                      payload: { pageNo: page, pageSize: pageSize }
                    });
                  }}
                />
              )}
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/UserReport.js